module.exports = __webpack_public_path__ + "img/diamond.43fbd05a.png";